<template>
  <div
    v-if="form"
    class="my-2"
  >
    <div class="row">
      <div class="col-md-7">
        <div class="mb-3">
          <span class="h4">#{{ request.id }}</span> <span class="lead">{{ form.name }}</span>
        </div>


        <strong>{{ $t('companyFormAdminView.irkt') }} </strong> {{ request.company.name }}
        {{ getCompanyFormat(request.company.format) }} <br>
        <strong>{{ $t('supplierOutgoingVendorRequest.mllif') }} </strong> {{ request.user.name }}
        {{ request.user.surname }} <br>
        <strong>{{ $t('supplierOutgoingVendorRequest.doldurulmaVaxt') }} </strong>{{
          getMoment(request.createTime)
        }}<br>
        <strong>{{ $t('supplierOutgoingVendorRequest.sonDyiiklikVaxt') }} </strong>{{
          getMoment(request.lastUpdateTime)
        }}<br>
        <strong>{{ $t('supplierOutgoingVendorRequest.gndrilmVaxt') }} </strong>{{ getMoment(request.sendTime) }}<br>
        <strong>{{ $t('companyFormAdminView.status') }}</strong>
        <CompanyFormRequestStatus :status="request.status" />

        <hr>

        <div v-for="s in sections">
          <h5>{{ s.title }}</h5>

          <div class="row">
            <template v-for="(i,j) in sectionInputs[s.id]">
              <VendorManagementDataView
                :key="values[i]"
                :input="i"
                :model-value="values[i.id]"
              />
            </template>
          </div>
          <div class="mt-2 p-2 border rounded ">
            <strong>Section Score: {{ sectionScore(s.id).toFixed(2) }} / {{ s.point }} points</strong>
          </div>
          <hr>
        </div>

        <!-- Display Form Total Score if Admin -->
        <div class="mt-3 p-2 border rounded ">
          <h5>Total Form Score: {{ totalScore.toFixed(2) }} / {{ formTotalPoints }} points</h5>
        </div>
        <div v-if="form.profileType==='SUPPLIER'">
          <h5>{{ $t('companySearch.faliyytSahlri') }}</h5>

          <div>
            <label
              v-for="s in sectors"
              class="d-block"
            >
              <input
                class="checkbox_animated"
                type="checkbox"
                disabled
                :checked="selectedSectors.indexOf(s.id+'')>-1"
              >
              {{ s.name }}
            </label>
          </div>
          <hr>
        </div>
        <div v-if="confirmationList.orders?.length!==0">
          <h5>Təsdiqlənmə siyahısı</h5>

          <div>
            <ul class="list-group">
              <li
                v-for="order in confirmationList.orders"
                :key="order.companyProfileOrderId"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <div class="d-flex align-items-center">
                  <!-- Status Icon -->
                  <span
                    class="status-icon mr-2"
                    v-html="getStatusIcon(order.status)"
                  />
                  {{ order.order }}. {{ order.fullName }}
                </div>

                <!-- Actions for REJECTED -->

                <div
                  v-if="order.status === 'REJECTED' && form.createdBy.id === user.id"
                  class="d-flex align-items-center"
                >
                  <button
                    class="btn btn-sm btn-info mr-2"
                    @click="showRejectReason(order.rejectReason)"
                  >
                    Bax
                  </button>
                  <button
                    class="btn btn-sm btn-success"
                    @click="resendOrder(order)"
                  >
                    Yenidən Göndər
                  </button>
                </div>

                <!-- "Təsdiqlə" button for the current user who is NOT admin -->
                <div
                  v-if="showConfirmButton(order)"
                  class="d-flex align-items-center"
                >
                  <button
                    class="btn btn-sm btn-primary"
                    @click="confirmOrder(order)"
                  >
                    Təsdiqlə
                  </button>
                  <button
                    class="btn btn-sm btn-primary m-1"
                    @click="rejectConfirmation(order)"
                  >
                    Rədd et
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- Select Profiles Section -->
        <div>
          <!-- Conditional Rendering -->
          <div v-if="(user.name + user.surname) === (company.adminName + company.adminSurname) ">
            <h6>Təsdiq üçün göndər</h6>
            <button
              class="btn btn-primary m-2"
              @click="openModal"
            >
              Siyahıdan seç
            </button>
            <ul
              v-if="selectedProfiles.length"
              class="mt-2 list-unstyled"
            >
              <li
                v-for="(profile, index) in selectedProfiles"
                :key="profile.companyUserId"
              >
                {{ index + 1 }}. {{ profile.fullName }}
              </li>
            </ul>
          </div>

          <!-- Bootstrap Modal -->
          <b-modal
            v-model="showModal"
            title="Siyahıdan seç"
            size="lg"
            hide-footer
          >
            <p>Formanın təsdiqi üçün əməkdaşların siyahısını formadan seçin.</p>

            <!-- Profile Selection -->
            <div class="form-check">
              <label
                v-for="(profile) in profiles"
                :key="profile.companyUserId"
                class="d-block"
              >

                <input
                  v-model="selectedIds"
                  class="checkbox_animated"
                  type="checkbox"
                  :value="profile.companyUserId"
                  @change="updateSelectedProfiles(profile)"
                >
                {{ profile.fullName }}
              </label>
            </div>
            <!-- Selected Profiles Order -->
            <div class="mt-3">
              <h6>Seçilmiş şəxslərin ardıcıllığı</h6>
              <ul class="list-unstyled">
                <li
                  v-for="(profile, index) in selectedProfiles"
                  :key="profile.userId"
                >
                  {{ index + 1 }}. {{ profile.fullName }}
                </li>
              </ul>
            </div>

            <!-- Modal Footer -->
            <div class="mt-3 text-right">
              <button
                class="btn btn-secondary"
                @click="closeModal"
              >
                Bağla
              </button>
              <button
                class="btn btn-success ml-2"
                @click="submitProfiles"
              >
                Göndər
              </button>
            </div>
          </b-modal>
        </div>
        <div>
          <button
            class="btn btn-primary m-2"
            @click="exportRequest('xlsx')"
          >
            {{ $t('vendorRequestDetailsReceiver.yklExcel') }}
          </button>
          <button
            class="btn btn-primary m-2"
            @click="exportRequest('pdf')"
          >
            {{ $t('vendorRequestDetailsReceiver.yklPdf') }}
          </button>
        </div>
        <div v-if="['WAITING'].indexOf(request.status)>-1 && form.createdBy.id === user.id && !allUsersConfirmed">
          <button
            class="btn btn-warning m-2"
            @click="returnRequest"
          >
            {{ $t('vendorRequestDetailsReceiver.mracitiGeriGndr') }}
          </button>
          <button
            class="btn btn-danger m-2"
            @click="rejectRequest"
          >
            {{ $t('vendorRequestDetailsReceiver.mracitiLvEt') }}
          </button>
          <button
            class="btn btn-danger m-2"
            @click="recallRequest"
          >
            {{ $t('vendorRequestDetailsReceiver.yenidnDoldurmaSorula') }}
          </button>
        </div>
        
        <div v-if="['WAITING'].indexOf(request.status)>-1 && form.createdBy.id === user.id && allUsersConfirmed">
          <button
            class="btn btn-warning m-2"
            @click="returnRequest"
          >
            {{ $t('vendorRequestDetailsReceiver.mracitiGeriGndr') }}
          </button>
          <button
            class="btn btn-danger m-2"
            @click="rejectRequest"
          >
            {{ $t('vendorRequestDetailsReceiver.mracitiLvEt') }}
          </button>
          <button
            class="btn btn-success m-2"
            @click="confirmRequest"
          >
            {{ $t('vendorRequestDetailsReceiver.mracitiTsdiql') }}
          </button>
        </div>

        <div v-if="['RETURNED'].indexOf(request.status)>-1 && form.createdBy.id === user.id">
          <button
            class="btn btn-danger m-2"
            @click="rejectRequest"
          >
            {{ $t('vendorRequestDetailsReceiver.mracitiLvEt') }}
          </button>
        </div>
        <div v-if="['REJECTED'].indexOf(request.status)>-1 && form.createdBy.id === user.id">
          <button
            class="btn btn-warning m-2"
            @click="returnRequest"
          >
            {{ $t('vendorRequestDetailsReceiver.mracitiGeriGndr') }}
          </button>
        </div>
        <div v-if="['APPROVED'].indexOf(request.status)>-1 && form.createdBy.id === user.id">
          <button
            class="btn btn-warning m-2"
            @click="returnRequest"
          >
            {{ $t('vendorRequestDetailsReceiver.mracitiGeriGndr') }}
          </button>
          <button
            class="btn btn-danger m-2"
            @click="rejectRequest"
          >
            {{ $t('vendorRequestDetailsReceiver.mracitiLvEt') }}
          </button>
          <button
            class="btn btn-danger m-2"
            @click="recallRequest"
          >
            {{ $t('vendorRequestDetailsReceiver.yenidnDoldurmaSorula') }}
          </button>
        </div>
        <div v-if="['EXPIRED'].indexOf(request.status)>-1 && form.createdBy.id === user.id">
          <div class="alert alert-info mb-2">
            {{ $t('vendorRequestDetailsReceiver.buMracitTdarkTrfindnYenidnDoldurulmaldr') }}
            <br>
            {{ $t('RFQOffersView.sbb', {reason: request.reason}) }}
          </div>
        </div>
      </div>
      <div class="col-md-5 position-relative">
        <div class=" sticky-top">
          <div class="card border border-dark">
            <div class="card-body h-100">
              <div class="chat-box">
                <div class="chat-right-aside">
                  <div class="chat">
                    <div class="chat-history chat-msg-box custom-scrollbar">
                      <ul>
                        <li
                          v-for="m in messages"
                          :key="m.id"
                          :class="`${m.author==='procurement'?'pl-5':'pr-5'}`"
                        >
                          <div
                            class="message"
                            :class="`${m.author==='procurement'?'other-message':'my-message'}`"
                          >
                            <img
                              v-if="m.author === 'procurement'"
                              alt=""
                              :src="getPhoto(form.company.logo,'thumbnailCropped')"
                              class="rounded-circle border bg-white float-right chat-user-img img-30"
                            >

                            <img
                              v-else
                              alt=""
                              :src="getPhoto(request.company.logo,'thumbnailCropped')"
                              class="rounded-circle border bg-white float-left chat-user-img img-30"
                            >

                            <div class="message-data mb-0 ">
                              <span class="message-data-time">{{ m.logTime }}</span>
                            </div>
                            {{ m.comment }}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer bg-light">
              <form @submit.prevent="sendMessage">
                <div class="input-group">
                  <input
                    v-model.trim="messageText"
                    type="text"
                    class="form-control"
                    :placeholder="$t('vendorRequestDetails.mesajMtniniDaxilEdin')"
                    required
                  >
                  <div class="input-group-append">
                    <button
                      type="submit"
                      class="btn btn-success"
                    >
                      <feather
                        type="send"
                        size="12"
                      />
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div
            v-if="!request.conversationActive"
            class="alert alert-light bg-secondary"
          >
            {{ $t('vendorRequestDetailsReceiver.buMracitNMzakirAktivDeyilMesajYazdnzdaMzakirAktivl') }}
          </div>

          <div
            v-else
            class="alert  border-secondary"
          >
            <div class="row">
              <div class="col-7">
                {{ $t('vendorRequestDetailsReceiver.mzakirHazrdaAktivdir') }}
              </div>
              <div class="col-5 text-right">
                <button
                  class="btn btn-sm btn-warning"
                  @click="closeConversation"
                >
                  {{ $t('conversationDetails.bala') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    {{ $t('login.yklnir') }}
  </div>
</template>
<script>
import {
  changeStatusCompanyProfileOrder,
  closeConversation,
  exportRequestNew,
  getConfirmationList,
  getFormRequestByIdReceiver,
  getFormRequestMessages,
  getOfflineForm,
  getProcurementProfiles,
  handleErrors,
  recallRequest,
  rejectRequest,
  returnRequest,
  sendCompanyProfileOrder,
  sendMessage
} from "@/repositories/VendorManagementRepository";
import {mapState} from "vuex";
import VendorManagementDataView from "@/pages/scc/vendorManagement/builder/VendorManagementDataView.vue";
import {getCompanyFormat, getPhoto} from "@/repositories/Utils";
import {mediaBase} from "@/repositories/Repository";
import CompanyFormRequestStatus from "@/pages/scc/vendorManagement/utils/CompanyFormRequestStatus.vue";
import moment from "moment";

export default {
  name: 'VendorRequestDetailsReceiver',
  components: {CompanyFormRequestStatus, VendorManagementDataView},
  props: {
    activeRequestId: {}
  },
  data() {
    return {
      showModal: false,        // Controls modal visibility
      selectedIds: [],         // Stores selected user IDs
      selectedProfiles: [],     // Stores selected profiles with order
      form: null,
      inputs: [],
      sections: [],
      sectors: [],
      profiles: [],
      values: [],
      selectedSectors: [],
      sectionInputs: {},
      request: null,
      confirmationList: null,
      messageText: '',
      messages: [],
      messageTimer: null
    };
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      company: state => state.auth.company,
      profile: state => state.auth.profile,
      user: state => state.auth.user,
      isAdmin: state => state.auth.hasAdmin
    }),
    allUsersConfirmed() {
      return this.confirmationList &&
          this.confirmationList.orders &&
          this.confirmationList.orders.length > 0 &&
          this.confirmationList.orders.every(order => order.status === 'FINISHED');
    },
    formTotalPoints() {
      // Sum up all section points for the form total
      return this.sections.reduce((sum, section) => sum + section.point, 0);
    },
    totalScore() {
      // Calculate the total score across all sections
      return this.sections.reduce((sum, section) => sum + this.sectionScore(section.id), 0);
    },
  },

  mounted() {
    this.getConfirmationList();
    this.getProcurementProfile();
    this.getRequestDetails();
    this.getRequestMessages(true);
    this.messageTimer = setInterval(() => {
      this.getRequestMessages(false);
    }, 10000)
  },

  unmounted() {
    clearInterval(this.messageTimer);
  },

  methods: {
    rejectConfirmation(order) {
      this.$swal({
        title: "Rədd Etmək İstədiyinizdən Əminsinizmi?",
        icon: "warning",
        input: "textarea", // Input for reject reason
        inputPlaceholder: "İmtina səbəbini daxil edin...",
        showCancelButton: true,
        confirmButtonText: "Bəli, Rədd Et",
        cancelButtonText: "İmtina",
        inputValidator: (value) => {
          if (!value) return "İmtina səbəbi tələb olunur!";
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.sendRejectOrder(order, result.value);
        }
      });
    },
    // Confirm Order
    confirmOrder(order) {
      this.$swal({
        title: "Təsdiqləmək İstədiyinizdən Əminsinizmi?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Bəli, Təsdiqlə",
        cancelButtonText: "İmtina"
      }).then((result) => {
        if (result.isConfirmed) {
          this.sendConfirmOrder(order);
        }
      });
    },
    sendRejectOrder(order, rejectReason) {
      changeStatusCompanyProfileOrder(this.token, order.companyProfileOrderId, 'REJECTED', rejectReason)
          .then(({code, message}) => {
            if (code === 200) {
              this.$swal({
                title: "Uğurla rədd edildi",
                icon: "success"
              }).then(() => {
                this.getConfirmationList(); // Refresh list
              });
            } else {
              this.$swal({
                title: "Xəta Baş Verdi",
                text: message,
                icon: "error"
              });
            }
          })
          .catch((error) => {
            console.error("Error confirming order:", error);
            this.$swal({
              title: "Bağlantı Xətası",
              text: "Serverə bağlantı zamanı problem yaşandı.",
              icon: "error"
            });
          });
    },
    // Send Confirm Order API Call
    sendConfirmOrder(order) {
      changeStatusCompanyProfileOrder(this.token, order.companyProfileOrderId, 'FINISHED', '')
          .then(({code, message}) => {
            if (code === 200) {
              this.$swal({
                title: "Uğurla Təsdiqləndi",
                icon: "success"
              }).then(() => {
                this.getConfirmationList(); // Refresh list
              });
            } else {
              this.$swal({
                title: "Xəta Baş Verdi",
                text: message,
                icon: "error"
              });
            }
          })
          .catch((error) => {
            console.error("Error confirming order:", error);
            this.$swal({
              title: "Bağlantı Xətası",
              text: "Serverə bağlantı zamanı problem yaşandı.",
              icon: "error"
            });
          });
    },

    showConfirmButton(order) {

      return (order.fullName === (this.user.name + ' ' + this.user.surname) && order.status === 'WAITING');
    },
    getConfirmationList() {
      getConfirmationList(this.token, this.activeRequestId).then((res) => {
        this.confirmationList = res;
        // Extract userIds from existing confirmed profiles
        if (res && res.orders) {
          const ids = [];
          const profiles = [];

          res.orders.forEach(order => {
            // Filter those who are still in WAITING status (or based on your logic)
            ids.push(order.companyUserId + '');
            profiles.push({
              companyUserId: order.companyUserId,
              fullName: order.fullName,
            });
          });

          // Sync both selectedIds and selectedProfiles
          this.selectedIds = ids;
          this.selectedProfiles = profiles;
        }
      });
    },
    // Get Status Icon
    getStatusIcon(status) {
      switch (status) {
        case 'WAITING':
          return `<i class="fa fa-clock-o text-warning" title="Gözləyir"></i>`;
        case 'REJECTED':
          return `<i class="fa fa-times-circle-o text-danger" title="İmtina edildi"></i>`;
        case 'FINISHED':
          return `<i class="fa fa-check-circle text-success" title="Bitdi"></i>`;
        default:
          return `<i class="fa fa-question-circle text-secondary" title="Naməlum"></i>`;
      }
    },

    // Show Reject Reason
    showRejectReason(reason) {
      if (reason) {
        this.$swal({
          title: "İmtina Səbəbi",
          text: reason,
          icon: "info"
        });
      } else {
        this.$swal({
          title: "İmtina Səbəbi",
          text: "İmtina səbəbi qeyd olunmayıb.",
          icon: "info"
        });
      }
    },

    // Resend Order
    resendOrder(order) {
      this.$swal({
        title: "Yenidən Göndərmək İstədiyinizdən Əminsinizmi?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Bəli, Göndər",
        cancelButtonText: "İmtina"
      }).then((result) => {
        if (result.isConfirmed) {
          this.changeStatusCompanyProfileOrder(order, "WAITING", "");
          this.getConfirmationList();
        }
      });
    },
    submitProfiles() {
      sendCompanyProfileOrder(this.token, this.request.id, this.selectedProfiles)
          .then(({code, message}) => {
            if (code === 200) {
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("srgGrGndrld"), // "Form sent successfully"
                icon: "success"
              }).then(() => {
                this.showModal = false;
                this.getConfirmationList();
              });
            } else if (code === 404) {
              this.$swal({
                title: this.$t("general.notFound"),
                text: this.$t("axtrdgnzFrmTpldm"), // "Form not found"
                icon: "error"
              });
            } else {
              this.$swal({
                title: this.$t("general.error"),
                text: message || this.$t("unknownError"), // Generic error message
                icon: "error"
              });
            }
          })
          .catch((error) => {
            console.error("Error submitting profiles:", error);
            this.$swal({
              title: this.$t("general.error"),
              text: this.$t("connectionError"), // "Connection error"
              icon: "error"
            });
          });
    },
    changeStatusCompanyProfileOrder(order, status, rejectReason) {
      changeStatusCompanyProfileOrder(this.token, order.companyProfileOrderId, status, rejectReason).then(res => {
        if (res.code === 200) {
          this.$swal({
            title: this.$t("generalModal.successTitle"),
            text: this.$t("srgGrGndrld"), // "Form sent successfully"
            icon: "success"
          }).then(() => {
            this.getConfirmationList()
            this.showModal = false; // Close modal after success
          });
        }
      })
    },
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    updateSelectedProfiles(profile) {
      const id = String(profile.companyUserId);
      const index = this.selectedProfiles.findIndex(p => String(p.companyUserId) === id);

      if (index === -1) {
        this.selectedProfiles.push(profile);
      } else {
        this.selectedProfiles = this.selectedProfiles.filter(
            p => String(p.companyUserId) !== id
        );
      }
    },
    sectionScore(sectionId) {
      // Calculate the total score for a section
      const inputs = this.sectionInputs[sectionId] || [];
      return inputs.reduce((sum, input) => {
        const settings = JSON.parse(input.settings || "{}");

        // Extract the actual text part before ':::' if it exists
        const inputValue = this.values[input.id];
        const [textPart] = inputValue ? inputValue.split(":::") : [""];

        // Find the matching option based on the extracted text part
        const selectedOption = settings.options?.find(
            option => option.text === textPart
        );

        // Calculate score based on the percentage of the selected option
        const percentage = selectedOption ? selectedOption.percentage : 0;
        return sum + ((percentage / 100) * input.point);
      }, 0);
    },

    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },

    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    calculateSectionInputs() {

      let map = {};

      this.sections.forEach((s) => {
        map[s.id] = [];
      })

      this.inputs.forEach((i) => {
        i.hash = JSON.stringify(i);
        map[i.companyFormSectionId].push(i);
      })

      this.sectionInputs = map;
    },

    getFormDetails(formId) {

      getOfflineForm(formId, this.$i18n.locale).then(({code, form, sectors, sections, inputs, message, errorCode}) => {
        if (code === 200) {
          this.form = form;
          this.sections = sections;
          this.inputs = inputs;
          this.sectors = sectors;

          this.calculateSectionInputs();

        } else if (code === 404) {
          this.$swal({
            title: this.$t("general.notFound"),
            text: this.$t("axtrdgnzFrmTpldm"),
            icon: 'error'
          }).then(() => {
            this.$router.back();
          })
        } else {
          handleErrors(this.$swal, data, null);
        }
      })
    },

    getRequestDetails() {
      getFormRequestByIdReceiver(this.token, this.activeRequestId).then(({code, form, message, errorCode}) => {
        if (code === 200) {
          this.values = JSON.parse(form.response);
          this.selectedSectors = form.sectors === null ? [] : form.sectors.split(',');
          this.request = form;

          this.getFormDetails(form.companyForm.id);

        } else if (code === 404) {
          this.$swal({
            title: this.$t("general.notFound"),
            text: this.$t("axtrdgnzFrmTpldm"),
            icon: 'error'
          }).then(() => {
            this.$router.back();
          })
        } else {
          handleErrors(this.$swal, data, null);
        }
      })
    },

    getRequestMessages(scroll) {
      getFormRequestMessages(this.token, this.activeRequestId)
          .then(({
                   code,
                   messages,
                   isConversationActive,
                 }) => {
            if (code === 200) {
              this.messages = messages;
              this.request.conversationActive = isConversationActive;

              if (scroll) {
                setTimeout(() => {
                  let container = document.querySelector(".chat-history");
                  if (container) {
                    container.scrollTop = container.scrollHeight;
                  }
                }, 500);
              }
            }
          })
    },

    returnRequest() {

      this.$swal({
        title: this.$t("generalModal.warningTitle"),
        icon: 'question',
        text: this.$t("grQytrlmSbbElvEdn"),
        input: 'textarea',
        inputValue: ''
      }).then((result) => {
        if (result.value) {
          returnRequest(this.token, this.activeRequestId, result.value)
              .then(({code, id, message, errorCode}) => {
                if (code === 200) {
                  this.$swal({
                    title: this.$t("generalModal.successTitle"),
                    text: this.$t("srgGrGndrld"),
                    icon: 'success'
                  }).then(() => {
                    this.getRequestDetails();
                    window.location.reload();
                  });

                } else if (code === 404) {
                  this.$swal({
                    title: this.$t("general.notFound"),
                    text: this.$t("axtrdgnzFrmTpldm"),
                    icon: 'error'
                  }).then(() => {

                  })
                } else {
                  handleErrors(this.$swal, data, null);
                }
              })
        }
      });
    },
    rejectRequest() {

      this.$swal({
        title: this.$t("dqqtIstfdcBuSrgnDzlsGrBlmyck"),
        icon: 'question',
        text: this.$t("lgvDlmSbbLvEdin"),
        input: 'textarea',
        inputValue: ''
      }).then((result) => {
        if (result.value) {
          rejectRequest(this.token, this.activeRequestId, result.value)
              .then(({code, id, message, errorCode}) => {
                if (code === 200) {
                  this.$swal({
                    title: this.$t("generalModal.successTitle"),
                    text: this.$t("srgGrGndrld"),
                    icon: 'success'
                  }).then(() => {
                    this.getRequestDetails();
                  });

                } else if (code === 404) {
                  this.$swal({
                    title: this.$t("general.notFound"),
                    text: this.$t("axtrdgnzFrmTpldm"),
                    icon: 'error'
                  }).then(() => {

                  })
                } else {
                  handleErrors(this.$swal, data, null);
                }
              })
        }
      });
    },
    recallRequest() {

      this.$swal({
        title: this.$t("yndnDldrmSrg"),
        icon: 'question',
        text: this.$t("yndnDldrlmSbbEdin"),
        input: 'textarea',
        inputValue: ''
      }).then((result) => {
        if (result.value) {
          recallRequest(this.token, this.activeRequestId, result.value)
              .then(({code, id, message, errorCode}) => {
                if (code === 200) {
                  this.$swal({
                    title: this.$t("generalModal.successTitle"),
                    text: this.$t("srgGrGndrld"),
                    icon: 'success'
                  }).then(() => {
                    this.getRequestDetails();
                  });

                } else if (code === 404) {
                  this.$swal({
                    title: this.$t("general.notFound"),
                    text: this.$t("axtrdgnzFrmTpldm"),
                    icon: 'error'
                  }).then(() => {

                  })
                } else {
                  handleErrors(this.$swal, data, null);
                }
              })
        }
      });
    },
    getProcurementProfile() {
      getProcurementProfiles(this.token, this.company.id).then((response) => {
        if (response.profiles) {
          // Filter profiles:
          this.profiles = response.profiles;
        }
      });
    },
    exportRequest(format) {

      exportRequestNew(this.token, this.activeRequestId, format)
          .then(({code, id, message, file, errorCode}) => {
            if (code === 200) {

              window.open(mediaBase + file);

            } else if (code === 404) {
              this.$swal({
                title: this.$t("general.notFound"),
                text: this.$t("axtrdgnzFrmTpldm"),
                icon: 'error'
              }).then(() => {

              })
            } else {
              handleErrors(this.$swal, data, null);
            }
          })
    },

    confirmRequest() {
      this.$emit('confirmRequest', {
        formId: this.form.id,
        requestId: this.request.id,
        form: this.form,
        sectors: this.sectors,
        selectedSectors: this.selectedSectors,
        company: this.form.company
      })
    },


    sendMessage() {

      sendMessage(this.token, this.activeRequestId, this.messageText)
          .then(({code, message, errorCode}) => {
            if (code === 200) {
              this.getRequestMessages(true);
              this.messageText = '';
            } else if (code === 404) {
              this.$swal({
                title: this.$t("general.notFound"),
                text: this.$t("axtrdgnzFrmTpldm"),
                icon: 'error'
              }).then(() => {

              })
            } else {
              handleErrors(this.$swal, data, null);
            }
          })
    },

    closeConversation() {

      this.$swal({
        title: this.$t("generalModal.warningTitle"),
        icon: 'question',
        text: this.$t("mzkrnBglmqIstdyMnsnz"),
        showCancelButton: true,
        confirmButtonText: this.$t("conversationDetails.bala"),
        cancelButtonText: this.$t("companyProfile.lvEt2"),
      }).then((result) => {
        if (result.value) {
          closeConversation(this.token, this.activeRequestId)
              .then(({code, id, message, errorCode}) => {
                if (code === 200) {
                  this.$swal({
                    title: this.$t("generalModal.successTitle"),
                    text: this.$t("mzkrBglnd"),
                    icon: 'success'
                  }).then(() => {
                    this.getRequestDetails();
                  });

                } else if (code === 404) {
                  this.$swal({
                    title: this.$t("general.notFound"),
                    text: this.$t("axtrdgnzFrmTpldm"),
                    icon: 'error'
                  }).then(() => {

                  })
                } else {
                  handleErrors(this.$swal, data, null);
                }
              })
        }
      });
    }
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
